import { axiosAuthInstance } from '../axiosInstance'

export function getMyInfoProviderData(id: any) {
  return axiosAuthInstance.get(`/v1/providers/${id}`)
}

export function getMyInfoPracticeData(id: any) {
  return axiosAuthInstance.get(`/v1/practices/${id}`)
}
